import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Calendar, Plus } from "lucide-react";
import api from "@/lib/api";
import { EventCard } from "@/components/cards";
import { Loader, SectionHeader, EmptyState, Chip, PrimaryButton, PASSION_LABEL } from "@/components/ui-bits";

const PASSIONS = ["photography", "fitness-wellness", "art-creative", "music", "cooking", "writing"];

export default function Events() {
  const [params, setParams] = useSearchParams();
  const passion = params.get("passion") || "";
  const [mode, setMode] = useState("");
  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    const q = new URLSearchParams();
    if (passion) q.set("passion", passion);
    if (mode) q.set("mode", mode);
    api.get(`/events?${q}`).then((r) => setItems(r.data));
  }, [passion, mode]);

  const setPassion = (p) => { const np = new URLSearchParams(params); p ? np.set("passion", p) : np.delete("passion"); setParams(np); };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
      <SectionHeader eyebrow="Events" title="Show up. Connect. Grow."
        subtitle="Photo walks, group runs, workshops and meetups — online and near you."
        action={<PrimaryButton as={Link} to="/create/event" data-testid="create-event-cta"><Plus className="h-4 w-4" />Create event</PrimaryButton>} />

      <div className="flex flex-wrap items-center gap-2 mb-8 overflow-x-auto pb-1">
        <Chip active={!passion} onClick={() => setPassion("")} data-testid="events-filter-all">All passions</Chip>
        {PASSIONS.map((p) => <Chip key={p} active={passion === p} onClick={() => setPassion(p)} data-testid={`events-filter-${p}`}>{PASSION_LABEL[p]}</Chip>)}
        <div className="ml-auto flex items-center gap-2">
          <Chip active={mode === ""} onClick={() => setMode("")}>All</Chip>
          <Chip active={mode === "online"} onClick={() => setMode("online")} data-testid="events-filter-online">Online</Chip>
          <Chip active={mode === "offline"} onClick={() => setMode("offline")} data-testid="events-filter-offline">In-person</Chip>
        </div>
      </div>

      {!items ? <Loader /> : items.length ? (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="events-grid">{items.map((e) => <EventCard key={e.id} e={e} />)}</div>
      ) : (
        <EmptyState icon={Calendar} title="No upcoming events" hint="Create an event for your community."
          action={<PrimaryButton as={Link} to="/create/event">Create event</PrimaryButton>} />
      )}
    </div>
  );
}
